import React from "react";
import { Divider } from "@mui/material";
import { InfoRow } from "./InfoRow";

interface HealthPlanProps {
  name: string;
}

export const HealthPlan: React.FC<HealthPlanProps> = ({ name }) => (
  <>
    <InfoRow label="Provider" value={name} />
    <InfoRow label="Coverage" value="In-Network" />
    <InfoRow label="Co-pay" value="$25" />
    <Divider sx={{ my: 1 }} />
  </>
);
